import { formatTimeString } from '../../utils/formatters'
import BaseExporter from './base_exporter'

export default class BusinessTxCSVExporter extends BaseExporter {
  export() {
    const data = this.data.map((entry) => {
      let dataRow = []
      if (!entry) {
        return new Array(this.header.length)
      }

      if (entry.name) {
        dataRow.push(entry.name)
      }

      if (entry.status) {
        dataRow.push(entry.status)
      }

      if (entry.created) {
        dataRow.push(formatTimeString(entry.created))
      }
      return dataRow
    })

    data.unshift(this.header)
    return data
  }
}
